import format from 'date-fns/format';

export const DEFAULT_DATE_PATTERN = 'DD MMM YYYY';

const formatDate = (date, pattern = DEFAULT_DATE_PATTERN) => format(date, pattern);

export { formatDate };
